"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stageBrandingInfo = stageBrandingInfo;
exports.stageCompanyLogoUrl = stageCompanyLogoUrl;
exports.stageCompanyLogoAltText = stageCompanyLogoAltText;
exports.stageCompanyAvatar = stageCompanyAvatar;
exports.stagePrimaryColor = stagePrimaryColor;
exports.stageSecondaryColor = stageSecondaryColor;
exports.stageAccentColor = stageAccentColor;
exports.stageAccent2Color = stageAccent2Color;
exports.resetStagedSettings = resetStagedSettings;
exports.saveBranding = exports.SaveBranding = exports.SaveBrandingActionTypes = exports.fetchBranding = exports.FetchBranding = exports.FetchBrandingActionTypes = exports.fetchCompanyInfo = exports.FetchCompanyInfo = exports.FetchCompanyInfoActionTypes = exports.BrandingActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var _Branding = _interopRequireDefault(require("./Branding"));

var BrandingActionTypes = (0, _namespacedKeyMirror.default)({
  // Network actions
  FETCH_COMPANY_INFO: null,
  FETCH_BRANDING: null,
  SAVE_BRANDING: null,
  // Stage actions
  STAGE_BRANDING_INFO: null,
  STAGE_COMPANY_LOGO_URL: null,
  STAGE_COMPANY_LOGO_ALT_TEXT: null,
  STAGE_COMPANY_AVATAR: null,
  STAGE_PRIMARY_COLOR: null,
  STAGE_SECONDARY_COLOR: null,
  STAGE_ACCENT_COLOR: null,
  STAGE_ACCENT2_COLOR: null,
  RESET_STAGED_SETTINGS: null
}, 'unifiedbranding');
exports.BrandingActionTypes = BrandingActionTypes;
var FetchCompanyInfoActionTypes = (0, _actions.createRequestTypes)(BrandingActionTypes.FETCH_COMPANY_INFO);
exports.FetchCompanyInfoActionTypes = FetchCompanyInfoActionTypes;
var FetchCompanyInfo = (0, _actions.createRequestActions)(FetchCompanyInfoActionTypes);
exports.FetchCompanyInfo = FetchCompanyInfo;
var fetchCompanyInfo = (0, _fluxActions.createAction)(BrandingActionTypes.FETCH_COMPANY_INFO);
exports.fetchCompanyInfo = fetchCompanyInfo;
var FetchBrandingActionTypes = (0, _actions.createRequestTypes)(BrandingActionTypes.FETCH_BRANDING);
exports.FetchBrandingActionTypes = FetchBrandingActionTypes;
var FetchBranding = (0, _actions.createRequestActions)(FetchBrandingActionTypes);
exports.FetchBranding = FetchBranding;
var fetchBranding = (0, _fluxActions.createAction)(BrandingActionTypes.FETCH_BRANDING);
exports.fetchBranding = fetchBranding;
var SaveBrandingActionTypes = (0, _actions.createRequestTypes)(BrandingActionTypes.SAVE_BRANDING);
exports.SaveBrandingActionTypes = SaveBrandingActionTypes;
var SaveBranding = (0, _actions.createRequestActions)(SaveBrandingActionTypes);
exports.SaveBranding = SaveBranding;
var saveBranding = (0, _fluxActions.createAction)(BrandingActionTypes.SAVE_BRANDING, function (branding) {
  return _Branding.default.toAPI(branding);
});
exports.saveBranding = saveBranding;

function stageBrandingInfo(key, payload) {
  return {
    type: BrandingActionTypes.STAGE_BRANDING_INFO,
    key: key,
    payload: payload || ''
  };
}

function stageCompanyLogoUrl(payload) {
  return {
    type: BrandingActionTypes.STAGE_COMPANY_LOGO_URL,
    payload: payload || ''
  };
}

function stageCompanyLogoAltText(payload) {
  return {
    type: BrandingActionTypes.STAGE_COMPANY_LOGO_ALT_TEXT,
    payload: payload || ''
  };
}

function stageCompanyAvatar(payload) {
  return {
    type: BrandingActionTypes.STAGE_COMPANY_AVATAR,
    payload: payload || ''
  };
}

function stagePrimaryColor(payload) {
  return {
    type: BrandingActionTypes.STAGE_PRIMARY_COLOR,
    payload: payload || ''
  };
}

function stageSecondaryColor(payload) {
  return {
    type: BrandingActionTypes.STAGE_SECONDARY_COLOR,
    payload: payload || ''
  };
}

function stageAccentColor(payload) {
  return {
    type: BrandingActionTypes.STAGE_ACCENT_COLOR,
    payload: payload || ''
  };
}

function stageAccent2Color(payload) {
  return {
    type: BrandingActionTypes.STAGE_ACCENT2_COLOR,
    payload: payload || ''
  };
}

function resetStagedSettings(payload) {
  return {
    type: BrandingActionTypes.RESET_STAGED_SETTINGS,
    payload: payload || ''
  };
}